import { isChrome, isEdge, isFirefox, isSafari } from 'react-device-detect'
export const getBrowser = () => {
  if (isChrome) return 'Chrome'
  if (isFirefox) return 'Firefox'
  if (isSafari) return 'Safari'
  if (isEdge) return 'Edge'
  return 'Chrome'
}
